import styled from "styled-components";


export const Container = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${props => props.theme.colors.typography1.light};

    > p {
        font-weight: 500;
        font-size: 1rem;

        @media(min-width:480px){
            font-size: 1.3rem;
            line-height: 25x;
        }

        @media(min-width:768px){
            font-size: 0.875rem;
            line-height: 17px;
        }
    }
`